/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    MdContentCopy,
    MdChatBubble,
    MdCompress,
    MdOutlineSync,
} from 'react-icons/md';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';

import {
    Button,
    Fab,
    FormControlLabel,
    FormControl,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    Tooltip,
    Tab,
    Tabs,
} from '@material-ui/core';

import FormCheckList from '~/components/Form/CheckList';
import FormSwitch from '~/components/Form/Switch';
import LocaleMessage from '~/components/LocaleMessage';
import SimpleDialog from '~/components/SimpleDialog';
import Splash from '~/components/Splash/Inside';

// import history from '~/services/history';
import api from '~/services/pluginbot-api';

import QnANodeAction from './QnANodeAction';
import QnANodeContext from './QnANodeContext';
import QnANodeNext from './QnANodeNext';
import QnANodeRequirements from './QnANodeRequirements';
import QnATest from './QnATest';
import { Container, FlowArea, ParameterArea, Panel } from './styles';
import TreeView from './TreeView';

const styleCenter = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};

export default function QnANodes({
    handleError,
    dialogSettings,
    answerLanguages,
}) {
    const settings = useSelector(state => state.settings || null);
    const loc = settings.locale;
    const lang = loc && loc.code ? loc.code : 'pt_BR';

    const {
        id: dialog_id,
        language: dialog_lng,
        settings: dialog_settings,
    } = dialogSettings;
    const agents =
        dialog_settings && dialog_settings.agents ? dialog_settings.agents : {};
    const training_agent = agents.training || '';

    const [dialogContents, setDialogContents] = useState({});
    const [dialogNodes, setDialogNodes] = useState({});

    const [body, setBody] = useState({});
    const [childrenOptions, setChildrenOptions] = useState([]);
    const [currComplementTab, setCurrComplementTab] = useState('found');
    const [currNode, setCurrNode] = useState(null);
    const [openBranches, setOpenBranches] = useState({});
    const [selectedFlow, setSelectedFlow] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [internalLoading, setInternalLoading] = useState(true);

    const [showRemoveDialog, setShowRemoveDialog] = useState(false);
    const [showNodeDialog, setShowNodeDialog] = useState('');
    const [showAnswerDialog, setShowAnswerDialog] = useState(false);
    const [showTestArea, setShowTestArea] = useState(false);

    async function loadDialogContents() {
        if (!dialog_id || !training_agent) {
            setDialogContents({});
            return;
        }
        await api
            .get(`dialogs/${dialog_id}/qna/contents?language=${dialog_lng}`)
            .then(response => {
                const list = response.data;
                const contents = {};
                const mapped = {};
                list.forEach(c => {
                    const c_type = c.type;
                    if (!contents[c_type]) contents[c_type] = [];
                    const item = {
                        id: c.id,
                        identifier: c.identifier,
                        type: c_type,
                        display_name: c.display_name,
                        grouping: c.grouping,
                    };
                    contents[c_type].push(item);
                    mapped[c.id] = item;
                });
                setDialogContents(contents);
            })
            .catch(error => handleError(error));
        setIsLoading(false);
    }

    async function loadNodes() {
        setIsLoading(true);
        if (!dialog_id || !training_agent) {
            setDialogNodes({});
            return;
        }
        await api
            .get(`dialogs/${dialog_id}/qna/nodes`)
            .then(response => {
                const nodes = response.data;
                const n_ids = {};
                nodes.forEach(n => {
                    n_ids[n.id] = n;
                });
                setDialogNodes(n_ids);
            })
            .catch(error => {
                handleError(error);
            });
        setIsLoading(false);
    }

    async function loadNode(_id) {
        if (!dialog_id || !training_agent) {
            return;
        }
        if (_id && _id !== 'new') {
            setInternalLoading(true);
            await api
                .get(`dialogs/${dialog_id}/qna/nodes/${_id}`)
                .then(response => {
                    const ans = response.data;
                    setBody(ans);
                })
                .catch(error => {
                    setBody({});
                    handleError(error);
                });
        } else {
            setBody({});
        }

        setInternalLoading(false);
        setIsLoading(false);
    }

    async function loadAll() {
        await Promise.all([loadNodes(), loadDialogContents()]);
    }

    async function createNode() {
        setInternalLoading(true);
        setShowNodeDialog('');

        const data = {
            ...body,
        };

        await api
            .post(`dialogs/${dialog_id}/qna/nodes`, data)
            .then(() => {
                toast.success(
                    <LocaleMessage msg="page.qna.content.update_success" />
                );
            })
            .catch(error => {
                handleError(error);
                return false;
            });

        setBody({});
        loadAll();
        setInternalLoading(false);
    }

    async function updateNode() {
        setInternalLoading(true);
        setShowNodeDialog('');
        setShowAnswerDialog(false);

        const data = { ...body };

        await api
            .put(`dialogs/${dialog_id}/qna/nodes/${currNode.id}`, data)
            .then(() => {
                toast.success(
                    <LocaleMessage msg="page.qna.content.update_success" />
                );
                return true;
            })
            .catch(error => {
                handleError(error);
                return false;
            });

        setCurrNode(null);
        loadAll();
        setInternalLoading(false);
    }

    async function removeNode() {
        setShowRemoveDialog(false);
        setInternalLoading(true);
        setShowAnswerDialog(false);

        await api
            .delete(`dialogs/${dialog_id}/qna/nodes/${currNode.id}`)
            .then(() => {
                toast.success(
                    <LocaleMessage msg="page.qna.content.update_success" />
                );
            })
            .catch(error => {
                handleError(error);
                return false;
            });

        setCurrNode(null);
        loadAll();
        setInternalLoading(false);
    }

    function handleCopy() {
        toast.info(<LocaleMessage msg="page.qna.nodes.list.node_id.copied" />);
    }

    // async function requestSuggestions() {
    //     const body_settings = body.settings || {};
    //     const lng_settings = body_settings[currLang]
    //         ? body_settings[currLang]
    //         : {
    //               ...(currLang !== dialog_lng && {
    //                   auto_translate: true,
    //               }),
    //           };
    //     const l_texts = lng_settings.texts || [''];

    //     const data = { language: currLang, examples: l_texts };
    //     let added_examples = 0;
    //     setInternalLoading(true);
    //     await api
    //         .post(`/qna/generate/${currNode.id}/answers`, data)
    //         .then(r => {
    //             const generated = r.data;
    //             const suggestions =
    //                 generated && generated.suggestions
    //                     ? generated.suggestions
    //                     : [];
    //             suggestions.forEach(s => {
    //                 added_examples++;
    //                 l_texts.push(s);
    //             });
    //             setBody({
    //                 ...body,
    //                 settings: {
    //                     ...body_settings,
    //                     [currLang]: {
    //                         ...lng_settings,
    //                         texts: l_texts,
    //                     },
    //                 },
    //             });
    //             toast.success(`${added_examples} AI Examples Added`);
    //         })
    //         .catch(error => handleError(error));
    //     setInternalLoading(false);
    // }

    useEffect(() => {
        loadAll();
    }, []);

    useEffect(() => {
        loadNode(currNode && currNode.id ? currNode.id : 'new');
    }, [training_agent, currNode]);

    // function handleGoToDialog() {
    //     const url = `/tools/dialogs/${dialog_id}/info`;
    //     history.push(url);
    // }

    function handleNodeActionClick(action, node) {
        const n_id = node.id;
        const actionHandlers = {
            add: () => {
                setShowNodeDialog('add');
                setChildrenOptions(node.children_type || []);
                setBody({
                    root: node.root,
                    condition_type:
                        node.children_type && node.children_type[0]
                            ? node.children_type[0]
                            : '',
                    contents: [],
                });
            },
            edit_children: () => {
                setCurrNode(node);
                setShowNodeDialog('children');
                setOpenBranches({
                    ...openBranches,
                    [n_id]: true,
                });
            },
            edit: () => {
                setCurrNode(node);
                setShowAnswerDialog(true);
            },
            delete: () => {
                setCurrNode(node);
                setShowRemoveDialog(true);
            },
            expand: () => {
                setOpenBranches({
                    ...openBranches,
                    [n_id]: !openBranches[n_id],
                });
            },
            null: () => {},
        };

        const handler = actionHandlers[action];
        if (handler) handler(n_id);
    }

    function handleTestAnswer(nodes) {
        const open = { ...openBranches };
        const selected = ['start', ...nodes];

        let n_id = nodes.pop();
        let steps = 1;

        const subject_list = dialogContents.subject || [];

        const subject_keys = {};
        subject_list.forEach(s => {
            subject_keys[s.id] = s;
        });

        while (n_id && steps < 10) {
            selected.push(n_id);
            open[n_id] = true;
            steps++;

            const c_node = dialogNodes[n_id];
            if (c_node) {
                if (c_node.root) {
                    n_id = c_node.root;
                } else {
                    n_id = '';
                    switch (c_node.condition_type) {
                        case 'command':
                            selected.push('commands');
                            open.commands = true;
                            break;
                        case 'intent':
                            selected.push('intents');
                            open.intents = true;
                            break;
                        case 'subject': {
                            selected.push('subjects');
                            open.subjects = true;
                            const { subject } = c_node;
                            const subject_data = subject_keys[subject] || {};
                            const { grouping } = subject_data;
                            if (grouping) {
                                const g_key = grouping.replace(' ', '');
                                selected.push(g_key);
                                open[g_key] = true;
                            }
                            break;
                        }

                        default:
                            break;
                    }
                }
            } else {
                n_id = '';
            }
        }
        setSelectedFlow(selected);
        setOpenBranches(open);
    }

    function handleDialogsClose() {
        setShowAnswerDialog(false);
    }

    function renderNodeRequirements() {
        return (
            <QnANodeRequirements
                dialogSettings={dialogSettings}
                answerLanguages={answerLanguages}
                config={body}
                saveConfig={c => {
                    setBody(c);
                }}
                handleError={e => handleError(e)}
            />
        );
    }

    function renderNodeAction() {
        return (
            <QnANodeAction
                dialogSettings={dialogSettings}
                answerLanguages={answerLanguages}
                config={body}
                saveConfig={c => {
                    setBody(c);
                }}
                handleError={e => handleError(e)}
            />
        );
    }

    function renderContextVariables() {
        const body_settings = body.settings || {};
        const ctxt_settings = body_settings.context || {};

        return (
            <QnANodeContext
                dialogSettings={dialogSettings}
                settings={ctxt_settings}
                saveSettings={s => {
                    setBody({
                        ...body,
                        settings: {
                            ...body_settings,
                            context: s,
                        },
                    });
                }}
            />
        );
    }

    function renderNodeNext() {
        return (
            <QnANodeNext
                dialogSettings={dialogSettings}
                answerLanguages={answerLanguages}
                config={body}
                saveConfig={c => {
                    setBody(c);
                }}
                handleError={e => handleError(e)}
            />
        );
    }

    function renderNodeProps() {
        return (
            <>
                <ParameterArea className="col-12 mb-3" style={styleCenter}>
                    {renderNodeAction()}
                </ParameterArea>

                <ParameterArea className="col-12 mb-3" style={styleCenter}>
                    {renderContextVariables()}
                </ParameterArea>

                <ParameterArea className="col-12 mb-3" style={styleCenter}>
                    {renderNodeNext()}
                </ParameterArea>
            </>
        );
    }

    function renderAnswerForm() {
        const allow_complement = body.condition_type === 'command';
        const show_complement = allow_complement && body.require_complement;

        return internalLoading ? (
            <Splash />
        ) : (
            <div className="col-12">
                <div className="col-12" style={styleCenter}>
                    {allow_complement ? (
                        <>
                            <ParameterArea
                                className="col-12 mb-3"
                                style={styleCenter}
                            >
                                <div
                                    className="col-12 row"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <strong>
                                        <LocaleMessage msg="page.qna.nodes.form.requirements" />
                                    </strong>
                                </div>
                                <div
                                    className="col-12 mt-3"
                                    style={styleCenter}
                                >
                                    <FormSwitch
                                        value={body.require_complement || false}
                                        onChange={event =>
                                            setBody({
                                                ...body,
                                                require_complement:
                                                    event.target.checked,
                                            })
                                        }
                                        label={
                                            <LocaleMessage msg="page.qna.nodes.form.requirements.complement.subject" />
                                        }
                                    />
                                </div>
                            </ParameterArea>
                            <ParameterArea
                                className="col-12 mb-3"
                                style={styleCenter}
                            >
                                {show_complement ? (
                                    <>
                                        <Tabs
                                            style={{ width: '100%' }}
                                            indicatorColor="primary"
                                            orientation="horizontal"
                                            value={currComplementTab || 'found'}
                                            onChange={(e, v) => {
                                                setCurrComplementTab(v);
                                            }}
                                            centered
                                        >
                                            <Tab
                                                value="missing"
                                                label={
                                                    <LocaleMessage msg="page.qna.nodes.form.requirements.complement.missing" />
                                                }
                                            />
                                            <Tab
                                                value="found"
                                                label={
                                                    <LocaleMessage msg="page.qna.nodes.form.requirements.complement.satisfied" />
                                                }
                                            />
                                        </Tabs>
                                        <div
                                            className="col-12 pt-3"
                                            style={{ flex: 1 }}
                                        >
                                            {currComplementTab === 'found'
                                                ? renderNodeProps()
                                                : renderNodeRequirements()}
                                        </div>
                                    </>
                                ) : (
                                    renderNodeProps()
                                )}
                            </ParameterArea>
                        </>
                    ) : (
                        renderNodeProps()
                    )}
                </div>
            </div>
        );
    }

    function renderAnswerDialog() {
        const title = (
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <span>
                    <>
                        <LocaleMessage msg="page.qna.nodes.form.edit" />
                        <span>
                            {body &&
                            body.name !== 'ELSE' &&
                            body.condition_type !== 'else'
                                ? ` - ${body.name || ''}`
                                : ''}
                        </span>
                    </>
                </span>
                {body.id ? (
                    <CopyToClipboard text={body.id} onCopy={() => handleCopy()}>
                        <Button
                            variant="outlined"
                            startIcon={<MdContentCopy />}
                        >
                            <LocaleMessage msg="page.qna.nodes.list.copy_id" />
                        </Button>
                    </CopyToClipboard>
                ) : null}
            </div>
        );

        return (
            <SimpleDialog
                size="md"
                open={showAnswerDialog}
                onClose={handleDialogsClose}
                title={title}
                content={renderAnswerForm()}
                actions={[
                    {
                        key: 'cancel',
                        onClick: () => setShowAnswerDialog(false),
                        label: <LocaleMessage msg="button.cancel" />,
                    },
                    {
                        key: 'submit',
                        onClick: () => updateNode(),
                        label: <LocaleMessage msg="button.save" />,
                    },
                ]}
            />
        );
    }

    function renderNodeChildrenForm() {
        const condition_type = body.condition_type || 'decision';

        const children_label = {
            subject: {
                yes: 'page.qna.nodes.form.bind_topics',
                no: 'page.qna.nodes.form.any_topic',
            },
            topic: {
                yes: 'page.qna.nodes.form.bind_questions',
                no: 'page.qna.nodes.form.any_question',
            },
        };

        const labels = children_label[condition_type] || {};

        return internalLoading ? (
            <Splash />
        ) : (
            <div className="col-12">
                <div
                    className="col-12"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ParameterArea
                        style={{
                            padding: '15px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <FormControl className="mt-3 mb-3">
                            <RadioGroup
                                value={`${body.allow_children || ''}`}
                                onChange={event =>
                                    setBody({
                                        ...body,
                                        allow_children: event.target.value,
                                    })
                                }
                            >
                                <FormControlLabel
                                    control={<Radio color="primary" />}
                                    value=""
                                    label={<LocaleMessage msg={labels.no} />}
                                />
                                <FormControlLabel
                                    control={<Radio color="primary" />}
                                    value="true"
                                    label={<LocaleMessage msg={labels.yes} />}
                                />
                            </RadioGroup>
                        </FormControl>
                    </ParameterArea>
                </div>
            </div>
        );
    }

    function renderNodeForm() {
        const condition_type = body.condition_type || 'decision';
        const type_contents =
            dialogContents && dialogContents[condition_type]
                ? dialogContents[condition_type]
                : [];
        const current_children = Object.keys(dialogNodes)
            .filter(n => {
                const node = dialogNodes[n];
                return node.root === body.root;
            })
            .map(i => {
                return dialogNodes[i];
            });
        const bound_contents = current_children.map(c => {
            const filters = {
                intent: 'intent',
                question: 'intent',
                decision: 'intent',
                subject: 'subject',
            };
            return c[filters[condition_type] || 'intent'];
        });
        const filtered_contents = type_contents.filter(c => {
            return !bound_contents.includes(c.id) && c.identifier !== 'SUBJECT';
        });

        return internalLoading ? (
            <Splash />
        ) : (
            <div className="col-12">
                <div
                    className="col-12"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ParameterArea
                        style={{
                            padding: '15px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <div className="col-md-4 col-12 mt-3">
                            <FormControl fullWidth className="mb-4">
                                <InputLabel>
                                    <LocaleMessage msg="page.qna.nodes.form.condition_type" />
                                </InputLabel>
                                <Select
                                    value={condition_type || ''}
                                    onChange={event =>
                                        setBody({
                                            ...body,
                                            condition_type: event.target.value,
                                        })
                                    }
                                >
                                    {childrenOptions.map(t => {
                                        return (
                                            <MenuItem
                                                key={`children_type_${t}`}
                                                value={t}
                                            >
                                                <LocaleMessage
                                                    msg={`page.qna.content.${t}`}
                                                />
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        {filtered_contents.length > 0 ? (
                            <FormCheckList
                                settings={body}
                                options={filtered_contents}
                                listKey="contents"
                                primaryLabelKey="display_name"
                                onChange={c => {
                                    setBody({
                                        ...body,
                                        contents: c.contents,
                                    });
                                }}
                            />
                        ) : (
                            <>
                                <span className="mt-3 mb-3">
                                    <LocaleMessage msg="page.qna.nodes.form.bind_contents.empty" />
                                </span>
                            </>
                        )}
                    </ParameterArea>
                </div>
            </div>
        );
    }

    function renderNodeDialog(type) {
        const contents = {
            add: {
                title: <LocaleMessage msg="page.qna.nodes.list.add" />,
                body: renderNodeForm(),
                action: {
                    key: 'submit',
                    onClick: () => createNode(),
                    label: <LocaleMessage msg="button.create" />,
                },
            },
            children: {
                title: <LocaleMessage msg="page.qna.nodes.form.edit" />,
                body: renderNodeChildrenForm(),
                action: {
                    key: 'submit',
                    onClick: () => updateNode(),
                    label: <LocaleMessage msg="button.save" />,
                },
            },
        };

        const node_form = contents[type] || contents.add;

        return (
            <SimpleDialog
                size="md"
                open={!!showNodeDialog}
                onClose={() => setShowNodeDialog('')}
                title={node_form.title}
                content={node_form.body}
                actions={[
                    {
                        key: 'cancel',
                        onClick: () => setShowNodeDialog(''),
                        label: <LocaleMessage msg="button.cancel" />,
                    },
                    node_form.action,
                ]}
            />
        );
    }

    function renderRemoveDialog() {
        return (
            <SimpleDialog
                size="sm"
                open={showRemoveDialog}
                onClose={() => setShowRemoveDialog(false)}
                title={<LocaleMessage msg="page.qna.nodes.list.delete" />}
                content={null}
                actions={[
                    {
                        key: 'cancel',
                        onClick: () => setShowRemoveDialog(false),
                        label: <LocaleMessage msg="button.cancel" />,
                    },
                    {
                        key: 'submit',
                        onClick: () => removeNode(),
                        label: <LocaleMessage msg="button.remove" />,
                    },
                ]}
            />
        );
    }

    function renderTestArea() {
        return showTestArea ? (
            <div className="col-md-3 col-12 p-0">
                <QnATest
                    dialog={dialog_id}
                    // nodes={dialogNodes}
                    languages={answerLanguages}
                    handleError={e => handleError(e)}
                    showAnswerFlow={nodes => handleTestAnswer(nodes)}
                    closeArea={() => {
                        setSelectedFlow([]);
                        setShowTestArea(false);
                    }}
                />
            </div>
        ) : null;
    }

    function renderFlowView() {
        return (
            <div
                className={`col-md-${showTestArea ? '9' : '12'} col-12`}
                style={{ padding: '0px' }}
            >
                <FlowArea isFullScreen>
                    {dialogNodes ? (
                        <TreeView
                            data={{
                                nodes: dialogNodes,
                                contents: dialogContents,
                            }}
                            labelLanguage={lang}
                            isFullScreen
                            selected={selectedFlow}
                            openBranches={openBranches}
                            onNodeAction={(a, n) => handleNodeActionClick(a, n)}
                        />
                    ) : null}
                    <div className="flow-buttons">
                        <div className="col-1">
                            <Tooltip
                                title={
                                    <LocaleMessage msg="page.qna.nodes.list.sync_all" />
                                }
                                placement="left"
                            >
                                <Fab
                                    className="mb-3"
                                    color="primary"
                                    onClick={() => {
                                        loadNodes();
                                        loadDialogContents();
                                    }}
                                >
                                    <MdOutlineSync
                                        style={{ color: '#fff' }}
                                        size={24}
                                    />
                                </Fab>
                            </Tooltip>
                            {!showTestArea ? (
                                <Tooltip
                                    title={
                                        <LocaleMessage msg="page.qna.nodes.test.title" />
                                    }
                                    placement="left"
                                >
                                    <Fab
                                        className="mb-3"
                                        color="primary"
                                        onClick={() => {
                                            setShowTestArea(true);
                                        }}
                                    >
                                        <MdChatBubble
                                            style={{ color: '#fff' }}
                                            size={24}
                                        />
                                    </Fab>
                                </Tooltip>
                            ) : null}
                            <Tooltip
                                title={
                                    <LocaleMessage msg="page.qna.nodes.list.collapse" />
                                }
                                placement="left"
                            >
                                <Fab
                                    className="mb-3"
                                    color="primary"
                                    onClick={() => {
                                        setOpenBranches({});
                                    }}
                                >
                                    <MdCompress
                                        style={{ color: '#fff' }}
                                        size={24}
                                    />
                                </Fab>
                            </Tooltip>
                            {/* <Tooltip
                                    title={<LocaleMessage msg="button.close" />}
                                    placement="left"
                                >
                                    <Fab
                                        className="mb-3"
                                        color="primary"
                                        onClick={() => {
                                            handleGoToDialog();
                                        }}
                                    >
                                        <MdClose
                                            style={{ color: '#fff' }}
                                            size={24}
                                        />
                                    </Fab>
                                </Tooltip> */}
                        </div>
                    </div>
                    {/* {renderTestArea()} */}
                </FlowArea>
            </div>
        );
    }

    function renderLoadingContents() {
        return (
            <Splash
                label={
                    <div className="mb-5">
                        <LocaleMessage msg="page.qna.content.training.loading" />
                    </div>
                }
                labelPosition="top"
            />
        );
    }

    return (
        <Container>
            <>
                <Panel>
                    {isLoading ? renderLoadingContents() : renderFlowView()}
                    {renderTestArea()}
                </Panel>

                {isLoading ? (
                    renderLoadingContents()
                ) : (
                    <>
                        {showRemoveDialog ? renderRemoveDialog() : null}
                        {showNodeDialog
                            ? renderNodeDialog(showNodeDialog)
                            : null}
                        {showAnswerDialog ? renderAnswerDialog() : null}
                    </>
                )}
            </>
        </Container>
    );
}

QnANodes.defaultProps = {
    answerLanguages: [],
};

QnANodes.propTypes = {
    handleError: PropTypes.func.isRequired,
    dialogSettings: PropTypes.object.isRequired,
    answerLanguages: PropTypes.array,
};
